/* eslint no-restricted-globals: ["off", "history"] */
import jump from 'jump.js';
import UrlPattern from 'url-pattern';
import Component from '../../../scripts/utilities/component';

class CompetitionForm extends Component {
    componentDidMount() {
        const maxWidth = 1023;
        this.smallValue = 90;
        this.largeValue = -100;
        this.mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
        this.scrollOffset = window.innerWidth < maxWidth ? this.smallValue : this.largeValue;
        this.answerOption = [...this.root.querySelectorAll('[data-ref="comp-option"]')];
        this.filteranswer = this.root.querySelector('[data-ref="drp-option"]');
        this.dropdownanswerOption = [...this.root.querySelectorAll('.competition-form__answers-list > li')];
        this.dropdownanswerList = this.root.querySelector('.competition-form__answers-list');
        this.anchoranswer = this.root.querySelector('.competition-form__anchor-image');
        this.termsOption = this.root.querySelector('[data-ref="terms-checkbox"]');
        this.ctaButton = this.root.querySelector('[data-ref="cta-button"]');
        this.successContainter = this.root.querySelector('[data-ref="entry-success"]');
        this.errorContainter = this.root.querySelector('[data-ref="entry-error"]');
        this.APIURL = this.props.url;
        this.scConfig = window.engms.compMessage;

        window.onload = () => {
            this.checkHash();

            if (this.dropdownanswerList != null) {
                this.dropdownanswerList.style.display = 'none';
            }            
        };

        this.bindEventListeners();

        // Check to see if there is a stored answer
        this.getLocalStorage();
        this.handleValidation();
    }

    bindEventListeners() {
        this.answerOption.forEach((option) => {
            option.addEventListener('click', this.handleValidation.bind(this));
        });

        if (this.anchoranswer != null) {
            this.anchoranswer.addEventListener('click', this.dropdowntoogle.bind(this));
        }
        if (this.filteranswer != null) {
            this.filteranswer.addEventListener('keyup', this.filter.bind(this));
            this.filteranswer.addEventListener('keyup', this.handleValidation.bind(this));
            this.filteranswer.addEventListener('focusout', this.handleValidation.bind(this));
        }
        
        var selectedOption = localStorage.getItem('fa-comp-answer');

        var i, dropvalue , selectedValue;
        for (i = 0; i < this.dropdownanswerOption.length; i++) {
            dropvalue = this.dropdownanswerOption[i];
            dropvalue.addEventListener('click', this.dropdownanswervalue.bind(dropvalue));
            dropvalue.addEventListener('click', this.handleValidation.bind(this));
            if (selectedOption) {
                if (selectedOption == this.dropdownanswerOption[i].getAttribute('data-value')) {
                    selectedValue = this.dropdownanswerOption[i].innerText;
                    document.getElementById('competition-form__search-input').value = selectedValue; 
                }
            }
        }

        this.termsOption.addEventListener('click', this.handleValidation.bind(this));

        this.ctaButton.addEventListener('click', this.handleAjaxCall.bind(this));

        document.addEventListener('modelClosed', this.resetForm.bind(this));

        this.mq.addListener((mql) => {
            if (mql.matches) {
                this.scrollOffset = this.smallValue;
            } else {
                this.scrollOffset = this.largeValue;
            }
        }); 
    }

    checkTextWithDropDownValue(txt) {
        var flag = false;
        var i;
        for (i = 0; i < this.dropdownanswerOption.length; i++) {
            var dropvalue = this.dropdownanswerOption[i].innerText;
            if (txt.toUpperCase() == dropvalue.toUpperCase()) {
                flag = true;
                var selId = this.dropdownanswerOption[i].getAttribute('data-value');
                var a = document.getElementById('competition-form__search-input');
          
                a.setAttribute('data-value', selId);
                break;
            }
        }

        return flag;
    }

    resetForm() {
        this.root.classList.remove('is--success');
        this.root.classList.remove('is--error');

        this.answerOption.forEach((option) => {
            const radioOption = option;
            radioOption.checked = false;
        });
        
        this.termsOption.checked = false;
        this.ctaButton.disabled = true;
        if (this.filteranswer != null) {
            this.filteranswer.setAttribute('data-value', "");
            this.filteranswer.value = "";
        }
    }

    checkHash() {
        const windowHash = window.location.hash;
        const parentSection = this.root.parentNode.parentNode;
        const sectionRef = `#${parentSection.getAttribute('data-section-ref')}`;

        if (windowHash === sectionRef) {
            const modal = this.root.parentNode;

            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }

            if (modal.getAttribute('data-component') === 'modal') {
                modal.classList.add('is--open');
            }

            jump(this.root, {
                offset: this.scrollOffset
            });
        }
    }

    handleValidation() {
        const answerInput = this.root.querySelector('input[data-ref="comp-option"]:checked');
        const termsCheckbox = this.root.querySelector('[data-ref="terms-checkbox"]:checked');

        var DDanswerInput = null;
        if (this.filteranswer != null) {
            var flag = this.checkTextWithDropDownValue(this.filteranswer.value);
            DDanswerInput = this.filteranswer.getAttribute('data-value');
           
        }  

        // Check answer selection for radio button
        if (answerInput && termsCheckbox) {
            this.selectAnswer = answerInput;
            this.termsCheck = termsCheckbox;
            this.ctaButton.disabled = false;
        }
        // Check answer selection for dropdown button
        else if (DDanswerInput && termsCheckbox && this.filteranswer.value !="" && flag == true) {
            this.selectAnswer = DDanswerInput;
            this.termsCheck = termsCheckbox;
            this.ctaButton.disabled = false;
        }
        else {
            this.ctaButton.disabled = true;
        }
    }

    handleAjaxCall(e) {
        e.preventDefault();
        this.ctaButton.classList.add('is--submitting');
        this.ctaButton.disabled = true;

        const httpRequest = new XMLHttpRequest();
      
        // Save answer
        if (this.selectAnswer.id == undefined)
            this.setLocalStorage(this.selectAnswer);
        else 
            this.setLocalStorage(this.selectAnswer.id);

        // Make request
        httpRequest.onreadystatechange = () => {
            if (httpRequest.readyState === 4) {
                this.handleResponse(httpRequest);
            }
        };

        if (this.selectAnswer.value == undefined) {
            httpRequest.open('POST', `${this.APIURL}?param=${this.selectAnswer}`, true);
        }
        else {
            httpRequest.open('POST', `${this.APIURL}?param=${this.selectAnswer.value}`, true);
        }

        httpRequest.send();
    }

    handleResponse(apiResponse) {
        // If response is not valid else continue
        if (apiResponse.status === 0 && apiResponse.responseText.length === 0) {
            const targetEl = this.errorContainter.getElementsByTagName('p')[0];
            const errorObj = {
                message: this.scConfig.cannotComplete,
                targetDiv: targetEl
            };
            this.renderResult(errorObj);
        } else {
            const { status, responseText } = apiResponse;
            const responseObject = {
                code: status,
                message: JSON.parse(responseText),
                targetDiv: ''
            };

            if (status === 200) {
                const targetEl = this.successContainter.getElementsByTagName('p')[0];
                responseObject.targetDiv = targetEl;
                this.renderResult(responseObject, true);
            } else if (status === 418) {
                // this is normal a 401/403 but due to code conflict
                // with sitecore, will have to use 418
                this.handleRedirect(responseObject);
            } else if (status === 409) {
                const targetEl = this.errorContainter.getElementsByTagName('p')[0];
                responseObject.targetDiv = targetEl;
                this.renderResult(responseObject);
            } else {
                const targetEl = this.errorContainter.getElementsByTagName('p')[0];
                responseObject.targetDiv = targetEl;
                this.renderResult(responseObject);
            }
        }
    }

    renderResult(obj, isSuccess) {
        let resultClass = '';

        if (isSuccess) {
            resultClass = 'is--success';
            // remove stored answer - no longer required to be saved
            this.removeLocalStorage();
        } else {
            resultClass = 'is--error';
        }

        const { message, targetDiv } = obj;
        targetDiv.innerHTML = `${message}`;
        this.root.classList.add(resultClass);
        this.ctaButton.classList.remove('is--submitting');
        this.ctaButton.disabled = false;

        jump('.competition-form', {
            offset: -100
        });
    }

    handleRedirect(obj) {
        const reponseUrl = obj.message.replace('www.', '');
        const currentUrl = window.location.host.replace('www.', '');
        const pattern = new UrlPattern('(http(s)\\://)(:subdomain.):domain.:tld(/*)');
        const responseUrlObj = pattern.match(reponseUrl);
        const currentUrlObj = pattern.match(currentUrl);
        let redirectTopLevel = '';
        let currentTopLevel = '';

        if (currentUrlObj) {
            const { domain, tld } = currentUrlObj;
            currentTopLevel = `${domain}.${tld}`;
        }

        if (responseUrlObj) {
            const { domain, tld } = responseUrlObj;
            redirectTopLevel = `${domain}.${tld}`;
        }

        if (currentTopLevel === redirectTopLevel) {
            window.location = obj.message;
        } else {
            const targetEl = this.errorContainter.getElementsByTagName('p')[0];
            const errorRefs = {
                message: this.scConfig.cannotComplete,
                targetDiv: targetEl
            };

            const errorsObj = Object.assign(obj, errorRefs);
            this.renderResult(errorsObj);
        }
    }

    getLocalStorage() {
        const selectedOption = localStorage.getItem('fa-comp-answer');

        if (selectedOption) {
            var selectedAnswer = document.getElementById('competition-form__search-input');
            if (selectedAnswer) {
                selectedAnswer.setAttribute('data-value', selectedOption);
            }
            else {
                const option = this.root.querySelector(`#${selectedOption}`);
                if (option) {
                    option.checked = true;
                }
            }        
        }
    }

    setLocalStorage(answer) {
        localStorage.setItem('fa-comp-answer', answer);
    }

    removeLocalStorage() {
        localStorage.removeItem('fa-comp-answer');
    }

    filter() {
        var input, div, filter, txtValue, a, i;
        input = this.root.querySelector('[data-ref="drp-option"]');
        filter = input.value.toUpperCase();
        div = this.root.querySelector('.competition-form__dropdown-row');
        a = div.getElementsByTagName("li");
        for (i = 0; i < a.length; i++) {
            txtValue = a[i].textContent || a[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                a[i].style.display = "";
            } else {
                a[i].style.display = "none";
            }
        }
    }

    dropdownanswervalue() {
        var selval = this.innerText;
        var selId = this.getAttribute('data-value');
        var a = document.getElementById('competition-form__search-input');
        a.value = selval;
        a.setAttribute('data-value', selId);
        var x = document.getElementById("competition-form__answers-dropdown");
        if (x.style.display === "none") {
            x.style.display = "table";
        } else {
            x.style.display = "none";
        }
    }

    dropdowntoogle() {
        var x = document.getElementById("competition-form__answers-dropdown");
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }
    }  
}

export default CompetitionForm;



// WEBPACK FOOTER //
// ./components/eng-ms-competition/scripts/competition-form.js